import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import PlusSm from '@/assets/icons/plus-sm.svg';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { useOpeningDetails } from '@/contexts/opening-context';

interface NoHiringGoalsProps {
  activeTab: string;
}

function NoHiringGoals({ activeTab }: NoHiringGoalsProps) {
  const intl = useIntl();
  const { hiringGoal } = useOpeningDetails();

  const getNoGoalText = (activeTab: string) => {
    switch (activeTab) {
      case 'past':
        return intl.formatMessage({
          defaultMessage: 'No past goals.',
          description: 'Empty “Past” tab: no completed hiring goals to list',
        });
      case 'scheduled':
        return intl.formatMessage({
          defaultMessage:
            'No scheduled goals. Create a new hiring goal to continue tracking spend.',
          description:
            'Empty “Scheduled” tab: prompt to add a future-dated goal',
        });
      default:
        return intl.formatMessage({
          defaultMessage:
            'No active goals. Create a new hiring goal to continue tracking spend.',
          description:
            'Empty “Active” tab: no in-progress hire-by goal to track',
        });
    }
  };

  return (
    <>
      <div className="flex flex-col items-center gap-6 self-stretch rounded-lg bg-white p-12">
        <div className="self-stretch text-center">
          <Typography variant="body1">{getNoGoalText(activeTab)}</Typography>
        </div>
        {activeTab !== 'past' && hiringGoal?.url && (
          <Button variant="secondary" asChild>
            <Link to={hiringGoal?.url} target="_blank">
              <img src={PlusSm} alt="Add" />
              <FormattedMessage
                defaultMessage="Add hiring goal"
                description="Button: open WX to create a hiring goal in new tab"
              />
            </Link>
          </Button>
        )}
      </div>
    </>
  );
}

export { NoHiringGoals };
